import * as Actions from './actions/actions'
import reducer from './reducers/index'
import watch from 'redux-watch'

export default class KeyframeDispatcher {
    constructor(settings, animator) {
        this._settings = settings;
        this._animator = animator;
    }

    getReducer() {
         return reducer;
    }

    initialize(store) {
        this._store = store;
    }

    subscribeAll(animDefs = []) {
        animDefs.forEach(this.subscribe);
    }

    /**
     * @callback keyframeTranslator
     * @param {Object} oldVal
     * @param {Object} newVal
     * @param {string} path
     */

    /** 
     * @param {Object} animDef 
     * @param {string} animDef.selector - Selector string used to call document.querySelector
     * @param {string} animDef.watchPath - Path to watch in state
     * @param {keyframeTranslator} animDef.translator - Translates state to keyframes
     * @param {duration} animDef.duration - Duration of animation in ms
     */
    subscribe(animDef) {
        let { selector, watchPath, translator, callback } = animDef;
        let watcher = watch(this._store.getState, watchPath);
        let changeHandler = (newVal, oldVal, path) => {
            let translation = translator(newVal, oldVal, path)
            if (!translation) return;
            let { attributes, duration } = translation;
            this._animator.start({ attributes, duration, selector, callback })
        };

        this._store.subscribe(watcher(changeHandler));
    }
}



// WEBPACK FOOTER //
// ./src/nextit-keyframe-dispatcher.js


// WEBPACK FOOTER //
// webpack:///src/nextit-keyframe-dispatcher.js